import { useState, useEffect, useContext } from "react";
import { AxiosResponse } from "axios";
import {
  typeApiResponse,
  countryDataTypes,
  countryRegionContextType,
  notificationContextTypes,
} from "../../utils/typeDefs";
import { apiUrls } from "../../utils/apiUrls";
import { NotificationContext } from "../../core/context/notificationContextProvider";
import {
  EditableTable,
  WtaHeaderCell,
} from "../generic/editableTable/editableTable.component";
import { Table } from "rsuite";
import { SerialCell } from "../generic/tableCell.component";
import { CountryCheckboxCell } from "../generic/editableTable/countryCheckboxCell.component";
import { EditableSelectPickerCell } from "../generic/editableTable/editableSelectCell.component";
import { typeCountryDto } from "../../utils/typeDefs";
import { getData, postData } from "../../utils/reusables";

const { Column, Cell } = Table;

const CountryTable = ({
  countryData,
  regionData,
}: countryRegionContextType) => {
  const [data, setData] = useState<typeCountryDto[] | [] | null>(null);
  const { triggerNotification } = useContext(
    NotificationContext
  ) as notificationContextTypes;

  const verticalMid = "middle";
  const centerAlign = "center";

  useEffect(() => {
    if (countryData.length > 0) {
      setData(countryData);
    }
  }, [countryData]);

  const onChange = async (rowData: typeCountryDto) => {
    const dataToPost = {
      CountryDtos: [
        {
          Id: rowData.id,
          RegionId: rowData.regionId,
          Name: rowData.name,
          Code: rowData.code,
          IsDisplay: rowData.isDisplay,
          Currency: rowData.currency,
          IsLowTax: rowData.isLowTax,
        },
      ],
    };

    postData(apiUrls.country.base, dataToPost)
      .then((result: AxiosResponse<typeApiResponse>) => {
        setData(null);
        return { status: result.data.succeeded, message: result.data.message };
      })
      .then((value) =>
        getData(apiUrls.country.base)
          .then((result: AxiosResponse<countryDataTypes & typeApiResponse>) => {
            setData(result.data.data);
            return result.data.succeeded;
          })
          .then(() => triggerNotification(value.status, value.message))
      )
      .catch((error) => {
        const reason = JSON.parse(error.message);
        triggerNotification(false, reason.data);
      });
  };

  const modifiedRegionData = [];

  for (let i = 0; i < regionData.length; i++) {
    const item = {
      label: regionData[i].name,
      value: String(regionData[i].id),
    };
    modifiedRegionData.push(item);
  }

  return (
    <>
      <div className="countryTableHeight my-2 shadow rounded">
        <EditableTable
          loading={data === null}
          data={data ? data : []}
          headerHeight={55}
          style={{ minWidth: "500px" }}
        >
          <Column width={140} verticalAlign={verticalMid} align={centerAlign}>
            <WtaHeaderCell className="d-flex">Country Id</WtaHeaderCell>
            <SerialCell dataKey={`id`} />
          </Column>
          <Column flexGrow={1} verticalAlign={verticalMid} align={centerAlign}>
            <WtaHeaderCell>Country Name</WtaHeaderCell>
            <Cell dataKey={`name`} />
          </Column>
          <Column flexGrow={1} verticalAlign={verticalMid} align={centerAlign}>
            <WtaHeaderCell>Code</WtaHeaderCell>
            <Cell dataKey={`code`} />
          </Column>
          <Column flexGrow={1} verticalAlign={verticalMid}>
            <WtaHeaderCell align="center">Low Tax</WtaHeaderCell>
            <CountryCheckboxCell
              onChangeEvent={onChange}
              dataKey={`isLowTax`}
            />
          </Column>
          <Column flexGrow={1} verticalAlign={verticalMid}>
            <WtaHeaderCell align="center">Display</WtaHeaderCell>
            <CountryCheckboxCell
              onChangeEvent={onChange}
              dataKey={`isDisplay`}
            />
          </Column>
          <Column flexGrow={1} verticalAlign={verticalMid}>
            <WtaHeaderCell align="center">Region</WtaHeaderCell>
            <EditableSelectPickerCell
              onChangeEvent={onChange}
              data={modifiedRegionData}
              dataKey={`regionId`}
            />
          </Column>
        </EditableTable>
      </div>
    </>
  );
};

export { CountryTable };
